// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"5477bdd5","359":"f508f5d5","476":"4b409ba2","639":"55663b32","681":"7c0c72b8"}[chunkId] + ".chunk.js";
};